<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step
        :complete="e1 > 1"
        step="1"
      >
        Campaign Details
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step
        :complete="e1 > 2"
        step="2"
      >
        Create Campaign
      </v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">
        Select Customers
      </v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <Channels @continue="onContinue" @cancel="onCancel" />
      </v-stepper-content>

      <v-stepper-content step="2">
        <WhatsappConfig v-if="campaignDetails.channel === 'whatsapp'" @cancel="onCancel" @continue="onWhatsappConfig" />
        <VoiceCallConfig v-if="campaignDetails.channel === 'call'" @selectVoiceFiles="onSelectCallVoiceFiles" @prev="onPrev" @cancel="onCancel" @continue="onVoiceCallConfig" />
      </v-stepper-content>

      <v-stepper-content step="3">
        <SelectCustomers :loading="creatingCampaign" @prev="onPrev" @cancel="onCancel" @continue="onSelectCustomers" />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import Channels from './Channels.vue'
import SelectCustomers from './SelectCustomers.vue'
import WhatsappConfig from './WhatsappConfig.vue'
import VoiceCallConfig from './VoiceCallConfig.vue'

export default {
  components: {
    Channels,
    SelectCustomers,
    WhatsappConfig,
    VoiceCallConfig
  },
  data () {
    return {
      authData: this.$storage.getUniversal("token"),
      e1: 1,
      creatingCampaign: false,
      campaignDetails: {
        campaignName: '',
        campaignDescription: '',
        channel: '',
	dateTimeEnd: '',
	dateTimeStart: '',
      },
      channelOptions: null,
      customers: [],
      voiceFiles: { customer: null, agent: null }
    }
  },
  methods: {
    onSelectCallVoiceFiles(voiceFiles) {
      this.voiceFiles = {
        customer: voiceFiles.customer,
        agent: voiceFiles.agent
      }
    },
    async createCampaign() {
      const payload = {
        title: this.campaignDetails.campaignName,
        description: this.campaignDetails.campaignDescription,
        channelType: this.campaignDetails.channel,
	dateTimeEnd: this.campaignDetails.dateTimeEnd,
	dateTimeStart: this.campaignDetails.dateTimeStart,
        channelOptions: this.channelOptions,
        customers: this.customers.map((c) => {
          return {
            name: c.customerFullName,
            phoneNo: c.crn,
            customer: c._id
          }
        })
      }

      try {
        this.creatingCampaign = true
        const response = await this.$axios.post("/workforce/campaign", payload, {
          headers: {
            Authorization: this.authData.access_token,
          },
        });

        if (this.campaignDetails.channel === "call") {
          const audioPayload = new FormData();
          audioPayload.append('customerVoiceFile', this.voiceFiles.customer);
          audioPayload.append('agentVoiceFile', this.voiceFiles.agent);
          audioPayload.append('campaignId', response.data.campaignId);

          await this.$axios.post("/workforce/campaign/call/audio", audioPayload, {
            headers: {
              Authorization: this.authData.access_token,
              "Content-Type": "multipart/form-data"
            },
          });
        }
        this.$toast.success("Successfully created campaign")
        this.$emit("create")
      } catch (err) {
        this.$toast.error(err.response.data.message)
      }
      this.creatingCampaign = false
    },
    onSelectCustomers({ selectedCustomers }) {
      this.customers = selectedCustomers
      this.createCampaign();
    },
    onPrev() {
      this.e1 = this.e1 - 1;
    },
    onCancel() {
      this.$emit("cancel")
    },
    onVoiceCallConfig(options) {
      this.e1 = 3
      this.channelOptions = options
    },
    onWhatsappConfig(campaignDetails) {
      this.e1 = 3
    },
    onContinue(campaignDetails) {
      this.campaignDetails = campaignDetails
      this.e1 = 2
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
